export default __webpack_public_path__ + "static/media/clean-lavender.9b097464.png";